var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"phone-login-button white--text",attrs:{"onclick":"window.location.href = '/login'"}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" mdi-cellphone ")]),_c('div',{staticClass:"vertical-line"},[_vm._v("   ")]),_c('p',{style:(_vm.style['pStyle'])},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }